"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var config = { debug: false, trackPageViews: false };
exports.configure = function (options) {
    Object.assign(config, options);
};
exports.signin = function (_a) {
    var id = _a.id, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, orgName = _a.orgName, customerChannel = _a.customerChannel, applicantChannel = _a.applicantChannel;
    var mixpanel = window.mixpanel;
    if (!mixpanel)
        return;
    mixpanel.alias(id);
    mixpanel.identify(id);
    // set_once would also work for undefined properties, and no-overwrites,
    // but that solution means mixpanel will never see user-updted properties
    mixpanel.people.set(__assign(__assign(__assign(__assign(__assign(__assign({}, (email && { $email: email })), (firstName && { $first_name: firstName })), (lastName && { $last_name: lastName })), (orgName && { $org_name: orgName })), (customerChannel && { $customer_channel: customerChannel })), (applicantChannel && { $applicant_channel: applicantChannel })));
};
exports.signup = exports.signin;
exports.signout = function () {
    var mixpanel = window.mixpanel;
    if (!mixpanel)
        return;
    mixpanel.reset();
};
exports.track = function (event, params) {
    if (params === void 0) { params = {}; }
    var mixpanel = window.mixpanel;
    if (!mixpanel)
        return;
    var metadata = utils_1.boolsToStr(params);
    if (config.debug)
        console.log('Mixpanel Event:', event, metadata); // eslint-disable-line no-console
    mixpanel.track(event, metadata);
};
exports.setSuperProperties = function (params) {
    if (params === void 0) { params = {}; }
    var mixpanel = window.mixpanel;
    if (!mixpanel)
        return;
    var props = utils_1.boolsToStr(params);
    mixpanel.register(props);
};
function setupPageViewTracking() {
    if (!config.trackPageViews)
        return;
    /* eslint-disable */
    // monkey patch history API for event listeners
    var patch = function (type) {
        var orig = history[type];
        return function () {
            var rv = orig.apply(this, arguments);
            try {
                exports.track('Page View');
            }
            catch (err) {
                console.error("Analytics Error: " + err);
            }
            return rv;
        };
    };
    history.pushState = patch('pushState');
    history.replaceState = patch('replaceState');
    /* eslint-enable */
    // track history back and forward
    window.addEventListener('popstate', function () { return exports.track('Page View'); });
    // track page view on load
    exports.track('Page View');
}
function getMetadata(element) {
    var prefix = 'analytics';
    var dataAttrs = utils_1.datasetToObject(element);
    return Object.keys(dataAttrs).reduce(function (result, key) {
        if (/^analytics/.test(key) && key !== prefix + "Event") {
            var noPrefix = key.substr(prefix.length);
            var newKey = noPrefix[0].toLowerCase() + noPrefix.slice(1);
            result[newKey] = dataAttrs[key];
        }
        return result;
    }, {});
}
exports.getMetadata = getMetadata;
function setupClickTracking() {
    document.addEventListener('click', function (event) {
        var target = event.target;
        while (target) {
            // eslint-disable-next-line prefer-destructuring
            var analyticsEvent = (target.dataset || {}).analyticsEvent;
            if (analyticsEvent) {
                var metadata = getMetadata(target);
                exports.track(analyticsEvent, metadata);
            }
            target = target.parentNode;
        }
    });
}
function onLoad() {
    try {
        setupPageViewTracking();
        setupClickTracking();
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error("Analytics error: " + err);
    }
}
exports.init = function (token, options) {
    // @ts-ignore
    (function (e, a) { if (!a.__SV) {
        var b = window;
        try {
            var c, l, i, j = b.location, g = j.hash;
            c = function (a, b) { return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null; };
            g && c(g, "state") && (i = JSON.parse(decodeURIComponent(c(g, "state"))), "mpeditor" === i.action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)));
        }
        catch (m) { }
        var k, h;
        window.mixpanel = a;
        a._i = [];
        a.init = function (b, c, f) { function e(b, a) { var c = a.split("."); 2 == c.length && (b = b[c[0]], a = c[1]); b[a] = function () { b.push([a].concat(Array.prototype.slice.call(arguments, 0))); }; } var d = a; "undefined" !== typeof f ? d = a[f] = [] : f = "mixpanel"; d.people = d.people || []; d.toString = function (b) { var a = "mixpanel"; "mixpanel" !== f && (a += "." + f); b || (a += " (stub)"); return a; }; d.people.toString = function () { return d.toString(1) + ".people (stub)"; }; k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" "); for (h = 0; h < k.length; h++)
            e(d, k[h]); a._i.push([b, c, f]); };
        a.__SV = 1.2;
        b = e.createElement("script");
        b.type = "text/javascript";
        b.async = !0;
        b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
        c = e.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(b, c);
    } })(document, window.mixpanel || []); // eslint-disable-line
    mixpanel.init(token, __assign(__assign({}, options), { loaded: function () { return onLoad(); } }));
};
